/** Typbezeichnung des OnlineBrief24-Briefwegs in `integrationType` der Sendungen. */
const ONLINEBRIEF24_INTEGRATION_TYPE = "OnlineBrief24";

/**
 * Briefweg / Provider-Anzeige für Posteingang (Inbound) und Postausgang (Outbound).
 */
export function letterProviderRouteLabel(
  integrationDisplayName: string | null | undefined,
  integrationType: string | null | undefined,
  text: (key: string) => string
): string {
  const display = (integrationDisplayName ?? "").trim();
  if (display.length > 0) return display;
  const typ = (integrationType ?? "").trim();
  if (typ === ONLINEBRIEF24_INTEGRATION_TYPE) return text("OnlineBrief24 integration");
  if (typ.length > 0) return typ;
  return text("Inbox letter dispatch local");
}
